// extracted by mini-css-extract-plugin
export var createdDate = "_nw-1";
export var divider = "_nw-2";
export var headerDivider = "_nw-3";
export var messagesCard = "_nw-0";
export var messagesContainer = "_nw-7";
export var messagesContainerWrapper = "_nw-4";
export var pointerCapturingButtonBoxes = "_nw-a";
export var showLeftPanelButton = "_nw-9";
export var showMoreButton = "_nw-c";
export var showMoreButtonContainer = "_nw-b";
export var summaryTitle = "_nw-6";
export var systemMessageCardWrapper = "_nw-d";
export var topButtons = "_nw-8";
export var withPadding = "_nw-5";